export const filterObjectWithValues = (obj = {}) => {
  if (!obj) return {};
  return Object.entries(obj).reduce((acc, [key, value]) => {
    // Check if value is an array, preserve it if not empty
    if (Array.isArray(value)) {
      if (value.length > 0) {
        acc[key] = value;
      }
    }
    // Check if value is an object, and recursively filter it
    else if (typeof value === "object" && value !== null) {
      const filteredNestedObject = filterObjectWithValues(value);
      if (Object.keys(filteredNestedObject).length > 0) {
        acc[key] = filteredNestedObject;
      }
    }
    // Add key-value pair if the value is non-empty (for strings or other primitives)
    else if (value !== null && value !== undefined && value !== "") {
      acc[key] = value;
    }
    return acc;
  }, {});
};

export const filterObjectWithValues1 = (obj = {}) => {
  if (!obj) return {};

  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (Array.isArray(value)) {
      if (value.length > 0) acc[key] = value;
    } else if (typeof value === "object" && value !== null) {
      const filteredNestedObject = filterObjectWithValues(value);
      if (Object.keys(filteredNestedObject).length > 0) {
        acc[key] = filteredNestedObject;
      }
    } else if (value !== null && value !== undefined && value !== "") {
      acc[key] = value;
    }
    return acc;
  }, {});
};